module.exports = "images/location_hotel.c22b7b1e51f414ad91cfbafe51cce31e.png";